import type {EmailAddressee} from 'nutshell-core/types';

/**
 * Helper function to turn an email addressee into something we can
 * display. Normally, this won't matter, but in the case that the
 * email address doesn't have an entity associated with it, we'll
 * want to display alternative information for the name.
 *
 * @param  {Object} addressee    - Email addressee object to parse
 * @param  {boolean} includeAddress    - Include address in name
 * @return {Object}              - "Entity-ish" object with keys we expect
 */
export function normalizeEmailAddresseeEntity(addressee: EmailAddressee) {
    return addressee.entity
        ? addressee.entity
        : {
              type: 'unknown',
              name: addressee.display || addressee.address,
              // @ts-expect-error
              initials: (addressee.display || addressee.address)[0].toLowerCase(),
              avatarUrl: '',
              htmlUrl: null,
          };
}
